import { RichTextRenderer } from '@lighthouse/shared'
import styled from 'styled-components'

import { AnimationDecorators } from '../../components'

export const Root = styled(AnimationDecorators)`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: var(--block-padding);
`

export const CollapseRoot = styled.div`
    /* padding: 16px 16px 12px; */
    border-radius: 12px;
    background-color: var(--color-gray-100);
`
export const CollapseTitle = styled(RichTextRenderer)`
    > div {
        font-size: 16px;
        line-height: 24px;
        color: var(--color-gray-900);
    }
`
export const CollapseSubTitle = styled(RichTextRenderer)`
    > div {
        font-size: 14px;
        line-height: 22px;
        color: var(--color-gray-800);
    }
`
export const CollapseContent = styled(RichTextRenderer)`
    padding: 12px 16px;
    > div {
        color: var(--color-gray-500);
        line-height: 24px;
    }
`
